/* FWF cards
   1) If a card's chips don't fit on one line, switch the perks to icons.
   2) If a product image has a white background (all four corners white), blend it into the tile color. */
(function () {
  function tooFull(row) {
    var group = row.querySelector('.fwf-chips__group') || row;
    var last = group.lastElementChild;
    return !!last && last.getBoundingClientRect().right > row.getBoundingClientRect().right + 1;
  }
  // Steps down until the chips fit: full labels -> icons -> tighter icons -> shorter Signed label
  function fit(row) {
    row.classList.remove('fwf-chips--icons', 'fwf-chips--tight', 'fwf-chips--short');
    if (!tooFull(row)) return;
    row.classList.add('fwf-chips--icons');
    if (!tooFull(row)) return;
    row.classList.add('fwf-chips--tight');
    if (!tooFull(row)) return;
    row.classList.add('fwf-chips--short');
  }
  function fitAll() { document.querySelectorAll('.fwf-chips').forEach(fit); }
  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) { entries.forEach(function (e) { fit(e.target); }); })
    : null;
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) fit(e.target); }); })
    : null;

  function isWhite(d, i) { return d[i] >= 243 && d[i + 1] >= 243 && d[i + 2] >= 243 && d[i + 3] > 200; }
  function checkBg(img) {
    if (img.hasAttribute('data-fwf-bg')) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    img.setAttribute('data-fwf-bg', '');
    var url;
    try { url = new URL(src, location.href); url.searchParams.set('width', '60'); } catch (e) { return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h) return;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d');
        ctx.drawImage(probe, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data;
        var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]];
        var white = pts.every(function (p) { return isWhite(d, (p[1] * w + p[0]) * 4); });
        if (white) img.classList.add('fwf-whitebg');
      } catch (e) { /* image not readable; leave as is */ }
    };
    probe.src = url.toString();
  }
  function scanImages() {
    document.querySelectorAll('.product-card .product-card__image--main img:not([data-fwf-bg])').forEach(function (img) {
      if (img.complete && (img.currentSrc || img.src)) checkBg(img);
      else img.addEventListener('load', function () { checkBg(img); }, { once: true });
    });
  }

  function watch() {
    scanImages();
    var fresh = document.querySelectorAll('.fwf-chips:not([data-fwf])');
    if (!fresh.length) return;
    fresh.forEach(function (row) {
      row.setAttribute('data-fwf', '');
      fit(row);
      if (ro) ro.observe(row);
      if (io) io.observe(row);
    });
    // Re-check shortly after, once fonts and layout have settled
    setTimeout(fitAll, 400);
    setTimeout(fitAll, 1500);
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; watch(); });
  }
  document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', function () { fitAll(); scanImages(); });
  if (document.fonts) {
    document.fonts.ready.then(fitAll);
    document.fonts.addEventListener && document.fonts.addEventListener('loadingdone', fitAll);
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();